import { mcaProcessColumns } from "../components/mca/mcaTableHelpers";

export const buildMcaProcessTableSchema = (overrides = {}) => ({
  searchableFields: ["name", "code", "cname"],
  byAggregation: false,
  columnFilterLayout: "toolbar",
  columns: mcaProcessColumns,
  ...overrides,
});
